import React from 'react'
import { useSelector } from 'react-redux'
export default function CoachItem(props) {
    const UContext = useSelector(state => state.firestoreUser.userData)
    return (

        <div>{UContext.role === "coach" && props.children}</div>
    )
}
